import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

// Hook para detectar si es móvil
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}

// Modal principal
const ModalOfertas = ({ isOpen, onClose, dataOfertas }) => {
  const isMobile = useIsMobile();
  const [view, setView] = useState("ofertas"); // productos | ofertas

  const hasOfertas = dataOfertas && dataOfertas.length > 0;
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        content: {
          position: 'relative',
          inset: 'unset',
          width: '95vw',
          maxWidth: '500px',
          maxHeight: '90vh',
          overflowY: 'auto',
          padding: '20px',
          borderRadius: '10px',
          border: 'none',
        },
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', fontFamily: 'Nunito Sans' }}>
        <h6 style={{ fontWeight: 'bold', fontSize: '16px' }}>
          Ofertas disponibles
        </h6>

        {/* Vista ofertas */}
        {view === "ofertas" && (
          hasOfertas ? (
            <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Producto</th>
                  <th>Lista</th>
                  <th>%</th>
                </tr>
              </thead>
              <tbody>
                {dataOfertas.map((oferta, idx) => (
                  <tr key={idx}>
                    <td>{oferta.producto_nombre}</td>
                    <td>{oferta.listado_nombre}</td>
                    <td>{oferta.porcentaje}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ fontStyle: 'italic', textAlign: 'center' }}>No hay ofertas disponibles.</p>
          )
        )}


        {/* Botones */}
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-evenly',
          gap: '10px',
          marginTop: '10px'
        }}>
              <button
                className="success"
                onClick={onClose}
                style={{
                  padding: '10px',
                  borderRadius: '8px',
                  backgroundColor: '#21BDA2',
                  color: '#fff',
                  border: 'none',
                  fontWeight: 600,
                  cursor: 'pointer',
                  width: isMobile ? '100%' : 'auto'
                }}
              >
                Aceptar
              </button>

        </div>
      </div>
    </ReactModal>
  );
};

export default ModalOfertas;
